import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/dC9Feg3hdeGqa4UKnUKs8W/WhatsApp_Image_2026-03-12_at_12.52.57.jpg';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const links = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Facilities',
    path: '/facilities'
  }, {
    name: 'Gallery',
    path: '/gallery'
  }, {
    name: 'FAQ',
    path: '/faq'
  }, {
    name: 'Contact Us',
    path: '/contact'
  }];
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-h2o-950/90 backdrop-blur-md border-b border-slate-800/50 py-3' : 'bg-transparent py-5'}`} data-id="element-153">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-154">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 focus-visible-ring rounded-lg" data-id="element-155">
          <img src={LOGO_URL} alt="H2O Event Centre Logo" className="h-[76px] md:h-[91px] w-auto rounded-md object-contain" data-id="element-156" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8" data-id="element-157">
          <ul className="flex items-center gap-6" data-id="element-158">
            {links.map(link => {
            const isActive = location.pathname === link.path;
            return <li key={link.name} data-id="element-159">
                  <Link to={link.path} className={`relative text-sm font-medium transition-colors hover:text-h2o-cyan focus-visible-ring rounded-sm py-1 ${isActive ? 'text-h2o-cyan' : 'text-slate-300'}`} data-id="element-160">
                    {link.name}
                    {isActive && <motion.div layoutId="navbar-indicator" className="absolute -bottom-1 left-0 w-full h-0.5 bg-h2o-cyan rounded-full" transition={{
                  type: 'spring',
                  stiffness: 300,
                  damping: 30
                }} data-id="element-161" />}
                  </Link>
                </li>;
          })}
          </ul>
          <Link to="/contact" className="bg-h2o-cyan text-h2o-950 font-semibold px-6 py-2.5 rounded-lg hover:bg-h2o-cyan-light transition-colors focus-visible-ring" data-id="element-162">
            Request a Tour
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button className="lg:hidden text-slate-300 hover:text-white focus-visible-ring rounded-md p-1" onClick={() => setIsOpen(true)} aria-label="Open menu" data-id="element-163">
          <Menu className="w-7 h-7" data-id="element-164" />
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-165">
        {isOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed inset-0 z-[60] bg-h2o-950 flex flex-col" data-id="element-166">
            <div className="flex items-center justify-between p-6 border-b border-slate-800/50" data-id="element-167">
              <img src={LOGO_URL} alt="H2O Event Centre Logo" className="h-[76px] w-auto rounded-md object-contain" data-id="element-168" />
              <button className="text-slate-300 hover:text-white focus-visible-ring rounded-md p-1" onClick={() => setIsOpen(false)} aria-label="Close menu" data-id="element-169">
                <X className="w-7 h-7" data-id="element-170" />
              </button>
            </div>
            <div className="flex flex-col p-6 gap-6 overflow-y-auto" data-id="element-171">
              <ul className="flex flex-col gap-4" data-id="element-172">
                {links.map(link => {
              const isActive = location.pathname === link.path;
              return <li key={link.name} data-id="element-173">
                      <Link to={link.path} className={`text-2xl font-heading font-semibold transition-colors block py-2 ${isActive ? 'text-h2o-cyan' : 'text-slate-300 hover:text-white'}`} data-id="element-174">
                        {link.name}
                      </Link>
                    </li>;
            })}
              </ul>
              <div className="mt-8 pt-8 border-t border-slate-800/50" data-id="element-175">
                <Link to="/contact" className="bg-h2o-cyan text-h2o-950 font-semibold px-6 py-4 rounded-lg hover:bg-h2o-cyan-light transition-colors w-full flex justify-center text-lg" data-id="element-176">
                  Request a Tour
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}